var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#F4A621",
    viewBox: "0 0 432 432",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m60 3 13 39 37 11c2 0 3 3 3 5-1 1-2 2-3 2L71 73l-11 37c0 2-3 3-5 3-1-1-2-2-2-3L40 71 3 60c-2 0-3-3-3-5 1-1 1-2 3-2l39-13L53 3c0-2 3-3 5-3 1 1 2 1 2 3zm88 110 7 21 20 6c2 1 3 3 2 5 0 1-1 2-2 2l-21 7-6 20c-1 2-3 3-5 2-1 0-2-1-2-2l-7-21-20-6c-2 0-3-2-3-4 1-2 2-3 3-3l21-7 6-20c0-2 2-3 4-2 2 0 2 1 3 2z M77 275c106-7 192-92 199-198 1-22-1-44-6-65-2-8 6-14 13-11 77 35 128 114 123 205-6 107-93 194-200 200-91 5-170-47-205-123-3-7 3-15 11-13 21 5 43 7 65 5zm262-45c2-5 6-7 11-6 4 1 7 6 6 10-8 29-23 55-44 75-20 21-46 36-75 44-4 1-9-2-10-6-1-5 1-9 6-11 26-7 49-20 67-39 19-18 32-41 39-67z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkTheme);
export default __webpack_public_path__ + "static/media/DarkTheme.1616d94f15479148e2a1f4fcd01e4bf4.svg";
export { ForwardRef as ReactComponent };